module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "card-item"
  }, [_c('div', {
    staticClass: "card-control"
  }, [_c('el-radio', {
    staticClass: "img-radio",
    attrs: {
      "label": _vm.Card_type
    }
  }, [_vm._v("\n          " + _vm._s(_vm.Card_type) + "款式\n          "), _c('lazy-component', [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": _vm.Card_ImgPath,
      "alt": _vm.Card_type + '型号模板'
    }
  })])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb06902","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QrcodeTypeCard.vue
// module id = 203
// module chunks = 1